import { AbstractControl, ValidatorFn } from '@angular/forms';

export function endDateAfterStartDateValidator(startControlName: string): ValidatorFn {
  return (endControl: AbstractControl): { [key: string]: any } | null => {
    if (!endControl.parent) { return null; }

    const startControl = endControl.parent.get(startControlName);
    if (!startControl) { return null; }

    const startDate = new Date(startControl.value);
    const endDate = new Date(endControl.value);

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) { return null; }

    return endDate >= startDate ? null : { endDateBeforeStartDate: true };
  };
}
